import { BankEligibility } from '@/domains/Business/types'
import { api } from '@/lib/api'

type UploadDocumentParams = {
  file: File
  businessId: string
  beneficialOwnerId: string
  step: string
}

export function uploadProofOfAddress({
  file,
  businessId,
  beneficialOwnerId,
  step,
}: UploadDocumentParams) {
  const formData = new FormData()

  formData.append('file', file)

  const stringifiedData = JSON.stringify({
    details: { businessId, beneficialOwnerId },
    step,
  })

  const dataAsBlob = new Blob([stringifiedData], {
    type: 'application/json',
  })

  formData.append('data', dataAsBlob)

  return api.post<BankEligibility>(
    `/v1/me/bank-eligibility/documents`,
    formData,
  )
}
